import {api} from "@/api/client";
import {Profile} from "@/api/types/Profile";

export type ProfileLog = {
    id: number,
    userId: string,
    email: string,
    name: string,
    title: string,
    createdAt: string,
    updatedAt: string,
    tenantId: string,
    tenantName: string,
    role: string
}

export type ProfileLogData = {
    total: number,
    limit: number,
    skip: number,
    data: ProfileLog[],
};

type ListParams = {
    limit?: number,
    skip?: number,
    search?: string,
};

type PatchParms = {
    id: number,
    role: string
}


export const buildProfileApi = (client = api) => {
    return {
        async get() {
            const result = await client.get<Profile>('api/profile');
            return result.data;
        },

        async patch(id: number, role: string) {
            const params: PatchParms = { id: id, role: role}
            const result = await client.patch<ProfileLog>('api/profile/logs', null, { params })
            return result.data
        },

        async getLogs(limit: number, skip: number, search: string) {
            const params: ListParams = { limit: limit, skip: skip, search: search }
            const result = await client.get<ProfileLogData>('api/profile/logs', { params })
            return result.data
        }
    };
};

export const {
    get,
    patch,
    getLogs,
} = buildProfileApi();
